import classnames from 'classnames';

const TextInput = (props) => {
	const { className, onInput } = props;

	const inputProps = Object.assign({}, props);

	if (onInput) {
		inputProps.onInput = (e) => onInput(e.target.value);
	}

	inputProps.className = classnames('sui-form-control', className);

	return <input {...inputProps} />;
};

export default TextInput;
